import base from './base';
import net from './net';
// import jwt from './net/token';

let util = {
  ...base,   //基础库
  ...net,  //网络请求库
}

const { cookie, format, log } = base;

// 用于“import util”可用
export default util;
// 用于“window.CNTarsUtil”
export {
  net, 
  // jwt,
  cookie, format, log
}


// WEBPACK FOOTER //
// ./src/index.js